// extracted by mini-css-extract-plugin
module.exports = {"Container":"CarCounterDashboard_Container__2xyo0","Paper":"CarCounterDashboard_Paper__r8U1g"};